import { render, staticRenderFns } from "./SaleGroupList.vue?vue&type=template&id=0375115a&"
import script from "./SaleGroupList.vue?vue&type=script&lang=js&"
export * from "./SaleGroupList.vue?vue&type=script&lang=js&"
import style0 from "./SaleGroupList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports